function normalizeFolderPath(value) {
  var raw = (value || "").toString().trim().replace(/\\/g, "/");
  raw = raw.replace(/^\/+/, "").replace(/\/+$/, "");
  if (!(raw)) return "";
  var parts = raw.split("/").filter(Boolean);
  var safe = [];
  for (var i = 0; i < parts.length; i++) {
    var token = parts[i];
    if (token === "." || token === "..") continue;
    safe.push(token.replace(/[^a-zA-Z0-9._-]/g, ""));
  }
  return safe.filter(Boolean).join("/");
}

function joinFolderPath(basePath, nextPath) {
  var base = normalizeFolderPath(basePath || "");
  var next = normalizeFolderPath(nextPath || "");
  if (base && next) return base + "/" + next;
  return base || next || "";
}

function folderWithinPrefix(pathValue, prefix) {
  var pathClean = normalizeFolderPath(pathValue || "");
  var prefixClean = normalizeFolderPath(prefix || "");
  if (!(prefixClean)) return true;
  if (!(pathClean)) return false;
  return (pathClean === prefixClean || pathClean.indexOf(prefixClean + "/") === 0);
}

function folderLabel(pathValue) {
  var cleaned = normalizeFolderPath(pathValue || "");
  if (!(cleaned)) return "Root";
  var parts = cleaned.split("/");
  return parts[parts.length - 1] || cleaned;
}

function folderParent(pathValue) {
  var cleaned = normalizeFolderPath(pathValue || "");
  if (!(cleaned)) return "";
  var parts = cleaned.split("/");
  parts.pop();
  return parts.join("/");
}

function buildFolderTreeItems(folderPaths) {
  var items = [];
  var seen = {};
  seen[""] = true;

  for (var i = 0; i < folderPaths.length; i++) {
    var normalized = normalizeFolderPath(folderPaths[i]);
    if (seen[normalized]) continue;
    seen[normalized] = true;
    items.push(normalized);
  }

  items.sort(function(a, b) { return a.localeCompare(b); });
  items.unshift("");
  return items;
}

function collectFoldersForFinder(folderPolicies, fileRows) {
  var set = {};
  set[""] = true;

  var policyRows = folderPolicies instanceof Array ? folderPolicies : [];
  for (var i = 0; i < policyRows.length; i++) {
    var policyPath = normalizeFolderPath(policyRows[i].path || "");
    if (!(policyPath)) continue;
    set[policyPath] = true;
  }

  var rows = fileRows instanceof Array ? fileRows : [];
  for (var r = 0; r < rows.length; r++) {
    var folderPath = normalizeFolderPath(rows[r].folder || "");
    if (!(folderPath)) continue;
    set[folderPath] = true;

    var parts = folderPath.split("/");
    var parent = "";
    for (var p = 0; p < parts.length - 1; p++) {
      parent = parent ? (parent + "/" + parts[p]) : parts[p];
      set[parent] = true;
    }
  }

  return buildFolderTreeItems(Object.keys(set));
}

module.exports = {
  normalizeFolderPath: normalizeFolderPath,
  joinFolderPath: joinFolderPath,
  folderWithinPrefix: folderWithinPrefix,
  folderLabel: folderLabel,
  folderParent: folderParent,
  buildFolderTreeItems: buildFolderTreeItems,
  collectFoldersForFinder: collectFoldersForFinder
};
